import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  templateUrl: './member-blacklist.component.html',
  styleUrls: ['./member-blacklist.component.scss']
})
export class MemberBlacklistDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<MemberBlacklistDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: string) {}

  ngOnInit() {
  }

  onCloseDialog() {
    this.dialogRef.close();
  }
}
